import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MapContext } from '../../Map';
import './Zoom.css';

var Zoom = function Zoom(_ref) {
  var _ref$zoomInTipText = _ref.zoomInTipText,
      zoomInTipText = _ref$zoomInTipText === undefined ? 'Zoom in' : _ref$zoomInTipText,
      _ref$zoomOutTipText = _ref.zoomOutTipText,
      zoomOutTipText = _ref$zoomOutTipText === undefined ? 'Zoom out' : _ref$zoomOutTipText;

  var _useContext = useContext(MapContext),
      zoomIn = _useContext.zoomIn,
      zoomOut = _useContext.zoomOut;

  return React.createElement(
    'div',
    { className: 'zoom-control--root' },
    React.createElement(
      'button',
      {
        className: 'zoom-in',
        title: zoomInTipText,
        onClick: function onClick() {
          return zoomIn();
        }
      },
      React.createElement(
        'svg',
        { viewBox: '0 0 16 16' },
        React.createElement('path', { d: 'M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z' })
      )
    ),
    React.createElement(
      'button',
      {
        className: 'zoom-out',
        title: zoomOutTipText,
        onClick: function onClick() {
          return zoomOut();
        }
      },
      React.createElement(
        'svg',
        { viewBox: '0 0 16 16' },
        React.createElement('path', { d: 'M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z' })
      )
    )
  );
};

Zoom.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Tool tip text for zoom in button
   */
  zoomInTipText: PropTypes.string,
  /**
   * Tool tip text for zoom out button
   */
  zoomOutTipText: PropTypes.string
} : {};

export default Zoom;